import { useDispatch } from 'react-redux';
import debounce from 'transmute/debounce';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
import { setLineItemBlur } from '../state/lineItemBlursSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DEBOUNCE_DELAY = 200;
const CustomQuantityInput = ({
  id,
  quantity,
  min,
  max,
  error
}) => {
  const dispatch = useDispatch();
  const applyValueChange = value => {
    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue === '') {
        return;
      }
    }
    const numValue = Number(value);
    if (isNaN(numValue) || !isFinite(numValue)) {
      return;
    }
    const adjustedValue = Math.max(min, Math.min(max, numValue));
    dispatch({
      type: BuyerOverridesActionTypes.SET_QUANTITY,
      data: {
        id,
        quantity: adjustedValue
      }
    });
    dispatch(setLineItemBlur({
      lineItemId: id,
      isBlurred: true
    }));
  };
  const handleValueChange = debounce(DEBOUNCE_DELAY, event => {
    applyValueChange(event.target.value);
  });
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyValueChange(event.currentTarget.value);
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    gap: "200",
    alignItems: "center",
    "data-test-id": "custom-quantity-input",
    maxInlineSize: "100px",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      children: "x"
    }), /*#__PURE__*/_jsx(NumberInput, {
      id: `${id}`,
      name: "line-item-quantity",
      "aria-label": "Line Item quantity",
      onBlur: handleValueChange,
      onKeyDown: handleKeyDown,
      min: min,
      max: max,
      error: error,
      value: quantity
    })]
  });
};
export default CustomQuantityInput;